<template>
  <div class="p-0 m-0">

    <div class="col-12 p-0 m-0 " v-if="image != null">
      <img class="col-12 position-relative p-0 m-0 products-3-header-image" :src="image" :alt="alt">
      <div class="centered">


        <div class="col-12" v-if="productCategoriesNames.length > 0">
          <m-a :href="{name:'SingleCategory',params:{slug:category.slug}}"
               v-for="category in productCategoriesNames"
               class="text-decoration-none h3">
            <m-icon icon="chevron-left" class="icon-color cursor-pointer"/>
            {{ category.name }}
          </m-a>
        </div>

        <m-a class="h3" v-else :href="{name:'Products'}">
          <span v-t="`product.single.breadcrumb_product`"></span>
        </m-a>


      </div>
    </div>

    <div class="container cursor-pointer">
      <filter-category2 @selectedCategory="setCategoryFromFromTop" v-if="chooseCategoriesFromTop"/>
    </div>

    <div class="container products-3-categories my-4" v-if="showCategoriesSlider">
      <m-categories-slider308 @category="setCategoryForWrapper" category-card="mCategoryCard203"/>
    </div>

    <div class="container">
      <div class="row">


        <div class="col-12 my-3 products-3-breadcrumb">
          <div class="row">

            <m-a :href="{name:'Home'}" class="text-decoration-none">
              <span v-t="`product.single.breadcrumb_home`"></span>
              <m-icon icon="chevron-left" class="icon-color"/>
            </m-a>

            <m-a :href="{name:'Products'}">
              <span v-t="`product.single.breadcrumb_product`"></span>
            </m-a>

            <m-a :href="{name:'SingleCategory',params:{slug:category.slug}}"
                 v-for="category in productCategoriesNames"
                 class="text-decoration-none">
              <m-icon icon="chevron-left" class="icon-color"/>
              {{ category.name }}
            </m-a>

          </div>
        </div>

        <div class="container"
             v-if="relatedCurrentCategory && showRelatedCategoriesSlider()">
          <m-categories-slider307 :singleCategory="singleCategory" @category="categorySliderCategory"/>
        </div>

        <!-- Button trigger modal -->
        <button type="button" class="btn mobile-filters-icon btn-primary d-md-none d-sm-block" data-toggle="modal"
                data-target="#mobile-filters">
          <i class="bi bi-list"></i>
        </button>

        <!-- Modal -->
        <div class="modal fade" id="mobile-filters" tabindex="-1" aria-labelledby="exampleModalLabel"
             v-if="windowWidth <= 767" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row mx-auto justify-content-center">
                  <div class="col-12" :class="setFilterOrder('brand')">
                    <m-filter-brand1 v-if="productBrandProp" :dirty-route="true"
                                     :brandColumn="productBrandColumn"
                                     :product-brands="productBrands"
                                     :brand-column="productBrandColumn"
                                     :brands-object="archiveFilter.brands"
                                     @brands="setProductBrand"/>
                  </div>
                  <div class="col-12" :class="setFilterOrder('feature')">
                    <m-filter-feature1 :dirty-route="true" :features-object="archiveFilter.features"
                                       :collapseOpen="productFeaturePanelOpenCloseProp"
                                       v-if="productFeatureProp"
                                       @features="setProductFeature" class="my-2"/>
                  </div>
                  <div class="col-12" :class="setFilterOrder('category')">
                    <m-filter-category1 :dirty-route="true" :categories="archiveFilter.category"
                                        v-if="productCategoryProp"
                                        :product-categories="productCategories"
                                        :category-column="productCategoryColumn"
                                        @categories="setProductCategory" class="my-2"/>
                  </div>

                  <div class="col-12" :class="setFilterOrder('search')">
                    <m-filter-search1 v-if="productSearchProp" @search="setProductSearch"/>
                  </div>
                  <div class="col-12" :class="setFilterOrder('quantity')">
                    <m-filter-quantity1 v-if="productQuantityProp" @quantityFilter="setQuantityFilter"/>
                  </div>
                  <div class="col-12" :class="setFilterOrder('store')">
                    <m-filter-multiple-store1 v-if="productStoresProp" :product-store="productStores"
                                              :store-column="productStoreColumn"
                                              @stores="setProductStore"/>
                  </div>
                  <div class="col-12 p-2" :class="setFilterOrder('price')">
                    <filter-price v-if="productPriceFilterProp" @price="setFilterPriceRange"/>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-sm-12 d-none d-md-block" v-if="windowWidth > 767">
          <div class="row mx-auto justify-content-center">
            <div class="col-12" :class="setFilterOrder('brand')">
              <m-filter-brand1 v-if="productBrandProp"
                               :brandColumn="productBrandColumn"
                               :dirty-route="true" :product-brands="productBrands"
                               :brand-column="productBrandColumn"
                               :brands-object="archiveFilter.brands"
                               @brands="setProductBrand"/>
            </div>
            <div class="col-12" :class="setFilterOrder('feature')">
              <m-filter-feature1 :dirty-route="true" :features-object="archiveFilter.features"
                                 :collapseOpen="productFeaturePanelOpenCloseProp"
                                 v-if="productFeatureProp"
                                 @features="setProductFeature" class="my-2"/>
            </div>
            <div class="col-12" :class="setFilterOrder('category')">
              <m-filter-category1 :categories="archiveFilter.category" v-if="productCategoryProp"
                                  :product-categories="productCategories"
                                  :category-column="productCategoryColumn"
                                  :dirty-route="true"
                                  @categories="setProductCategory" class="my-2"/>
            </div>

            <div class="col-12" :class="setFilterOrder('search')">
              <m-filter-search1 v-if="productSearchProp" @search="setProductSearch"/>
            </div>
            <div class="col-12" :class="setFilterOrder('quantity')">
              <m-filter-quantity1 v-if="productQuantityProp" @quantityFilter="setQuantityFilter"/>
            </div>
            <div class="col-12" :class="setFilterOrder('store')">
              <m-filter-multiple-store1 v-if="productStoresProp" :product-store="productStores"
                                        :store-column="productStoreColumn"
                                        @stores="setProductStore"/>
            </div>
            <div class="col-12 p-2" :class="setFilterOrder('price')">
              <filter-price v-if="productPriceFilterProp" @price="setFilterPriceRange"/>
            </div>

          </div>
        </div>

        <m-product-wrapper
            :per-page="perPage"
            :product-categories="productCategories"
            :product-category-column="productCategoryColumn"
            :wait-for-category="waitForCategory()"
            :product-brands="productBrands"
            :product-stores="productStores"
            :dashboard-product="dashboardProduct"
            :product-store-column="productStoreColumn"
            :product-brand-column="productBrandColumn"
            :wait-for-brand="waitForBrand()"
            :product-status="productStatus"
            :wait-for-store="waitForStore()"
            :product-quantity-filter="quantityFilter"
            :product-features="productFeatures"
            :product-search="productSearch"
            :product-sort="productSort"
            :product-price-filter="price"
            :infinity-loading="infinityLoading"
            :archive-filter-prop="archiveFilterProp"
            @archiveFilters="setArchiveFilters"
        >
          <template v-slot="{products,pagination,changePageFunction,skeletonStatus}">
            <div class="col-lg-9 archive-items col-sm-12">

              <m-sort-price-filter :publishStatusFilter="publishStatusFilter" @publishStatus="publishStatus"
                                   @sort="setProductSort" v-if="productSortProp"/>

              <div class="row">
                <div :class="cardWrapperCLass" v-for="product in products">

                  <m-a v-if="cardLink" :href="{ name: 'Product', params: { name: product.raw_link } }"
                       :target="cardLinkTarget">
                    <component :is="productCardNameComputed" :class="cardCLass"
                               :quantityStatusOnImage="quantityStatusOnImage"
                               :offer-status="offerStatus" :offerType="offerType"
                               :showKeywords="showKeywords"
                               :product="product"/>
                  </m-a>
                  <component v-else :is="productCardNameComputed" :class="cardCLass"
                             :quantityStatusOnImage="quantityStatusOnImage"
                             :offer-status="offerStatus" :offerType="offerType"
                             :showKeywords="showKeywords"
                             :product="product"/>

                </div>

                <div class="w-100 " id="products-card-skeleton-section"></div>

                <div :class="cardWrapperCLass" v-if="infinityLoading  && skeletonStatus" v-for="i in 3">
                  <div :class="cardCLass">
                    <component :is="skeleton"/>
                  </div>
                </div>

              </div>

              <div class="row pt-3 mt-3">
                <m-paginate1 :meta="pagination" :infinity-loading="infinityLoading"
                             :on-change-page="changePageFunction"/>
              </div>


            </div>
          </template>
        </m-product-wrapper>


      </div>
    </div>
  </div>
</template>

<script>
import mProductWrapper from "../../../Wrappers/ProductWrapper";
import mPaginate1 from "../../../Pagination/Paginate1";
import mFilterBrand1 from "../../../Brand/Filter/FilterBrand1";
import mFilterSearch1 from "../../../Search/Filter/FilterSearch1";
import mFilterQuantity1 from "../../../Product/QuantityManager/Filter/FilterQuantity1";
import mFilterFeature1 from "../../../Feature/Filter/FilterFeature1";
import mFilterCategory1 from "../../../Category/Filter/FilterCategory1/FilterCategory1";
import mFilterMultipleStore1 from "../../../MultipleStore/Filter/FilterMultipleStore1";
import mSortPriceFilter from "../../../Sort/Filter/SortPriceFilter";
import {Cards} from "../../Card/Cards";
import {OfferProps} from '../../../Product/ProductOffer/ProductOfferProps'
import mIcon from "../../../Icons/Icon.vue";
import mA from "../../../Tags/A.vue";
import mCategoriesSlider308 from "../../../Category/Slider/CategoriesSlider308.vue";
import FilterPrice from "../../Filter/FilterPrice.vue";
import SkeletonWrapper from "../../../Wrappers/SkeletonWrapper.vue";
import {ProductArchiveSkeleton} from "../../Skeleton/Archive/ProductArchiveSkeleton";
import {isNumber} from "lodash";
import FilterCategory2 from "../../../Category/Filter/FilterCategory2/FilterCategory2.vue";

export default {
  name: "Products3",
  components: {
    FilterCategory2,
    SkeletonWrapper,
    FilterPrice,
    mA, mIcon,
    ...Cards,
    ...ProductArchiveSkeleton,
    mProductWrapper,
    mPaginate1,
    mFilterBrand1,
    mFilterSearch1,
    mFilterQuantity1,
    mFilterFeature1,
    mFilterCategory1,
    mFilterMultipleStore1,
    mSortPriceFilter,
    mCategoriesSlider308,
  },
  props: {
    perPage: {
      default: 12,
    },
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    cardCLass: {
      default: 'my-1'
    },
    cardWrapperCLass: {
      default: 'col-lg-4 archive-parent-item'
    },
    showCategoriesSlider: {
      type: Boolean, default: false
    },
    ...OfferProps,
    productBrandProp: {type: Boolean, default: true},
    productSearchProp: {type: Boolean, default: true},
    productQuantityProp: {type: Boolean, default: true},
    productFeatureProp: {type: Boolean, default: true},
    productFeaturePanelOpenCloseProp: {type: Boolean, default: false},
    productCategoryProp: {type: Boolean, default: true},
    productStoresProp: {type: Boolean, default: true},
    productSortProp: {type: Boolean, default: true},
    relatedCurrentCategory: {type: Boolean, default: true},
    productPriceFilterProp: {type: Boolean, default: true},
    showKeywords: {
      type: Boolean,
      default: false
    },
    smCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    skeleton: {
      options: Object.keys(ProductArchiveSkeleton),
      default: 'mProductArchiveSkeleton1',
    },
    dashboardProduct: {type: Boolean, default: false},
    publishStatusFilter: {type: Boolean, default: false},
    image: {
      default: null
    },
    alt: {
      default: 'mix it web'
    },
    cardLink: {
      type: Boolean,
      default: true
    },
    infinityLoading: {
      type: Boolean,
      default: false
    },
    chooseCategoriesFromTop: {
      type: Boolean,
      default: false
    },
    cardLinkTarget: {
      options: ['_self', '_blank'],
      default: '_self',
    },
    productStoresDirectFilter: {
      default: null,
    },
    orderFilterProp: {
      type: Object,
      default: () => ['brand', 'feature', 'category', 'search', 'quantity', 'store', 'price'],
    },
    archiveFilterProp: {type: Boolean, default: false},

  },
  data() {
    return {
      productBrands: null,
      productStores: null,
      productCategories: null,
      productCategoriesNames: [],
      productFeatures: null,
      productSearch: '',
      quantityFilter: null,
      productBrandColumn: 'id',
      productStoreColumn: 'id',
      productCategoryColumn: 'id',
      productSort: '',
      windowWidth: window.innerWidth,
      singleCategory: null,
      screenSizeName: 'lg',
      productStatus: 'all',
      price: {
        minValue: null,
        maxValue: null,
      },
      archiveFilter: {
        brands: [],
        features: [],
        category: []
      },
    }

  },
  computed: {
    brand() {
      return brand
    },
    productCardNameComputed() {
      if (this.screenSizeName === 'sm') {
        return this.smCardName
      }

      return this.productCardName
    }
  },
  methods: {
    // todo move below method to ArchiveMethods.js ->
    // -> this will help us to create any design like pill-filter on slider products
    setProductBrand(brands) {
      this.productBrands = brands
    },
    setProductSort(type) {
      this.productSort = type
    },
    setProductBrandFromQuery() {
      let brand = this.$route.query.brand;
      let brandColumn = this.$route.query.brand_column
      if (brand !== undefined) {
        this.productBrands = []

        let brandList = Array.isArray(brand) ? brand : brand.split(',')

        brandList.forEach(item => {
          this.productBrands.push(item)
        })
      }
      if (brandColumn !== undefined) {
        this.productBrandColumn = brandColumn
      }
      return true
    },
    setProductStore(stores) {
      this.productStores = stores
    },
    setProductStoreFromQuery() {
      let store = this.$route.query.multiple_store;
      let storeColumn = this.$route.query.store_column
      if (store !== undefined) {
        this.productStores = []
        store.split(',').forEach(item => {
          this.productStores.push(item)
        })
      }
      if (storeColumn !== undefined) {
        this.productStoreColumn = storeColumn
      }
      return true
    },
    setProductCategoryFromQuery() {
      let category = this.$route.query.category;
      let categoryColumn = this.$route.query.category_column
      if (category !== undefined) {
        this.productCategories = []

        let categoryList = Array.isArray(category) ? category : category.split(',')
        //این نسخه false، null, undefined, 0, "", و NaN رو حذف می‌کنه.
        categoryList = categoryList.filter(item => !!item)
        categoryList.forEach(item => {
          this.productCategories.push(item)
        })
      }
      if (categoryColumn !== undefined) {
        this.productCategoryColumn = categoryColumn
      }
      return true
    },
    setProductFeature(features) {
      this.productFeatures = features
    },
    setProductFeatureFromQuery() {
      let features = this.$route.query.features;

      if (features != '' && features != undefined) {
        this.productFeatures = features.split(',')
      }

      return true


    },
    setProductPriceRangeFromQuery() {
      let minPrice = parseInt(this.$route.query.min_price)
      let maxPrice = parseInt(this.$route.query.max_price)
      if (isNumber(minPrice) && isNumber(maxPrice) && !isNaN(minPrice) && !isNaN(maxPrice)) {
        this.price = {
          minValue: minPrice,
          maxValue: maxPrice,
        }
      }

      return true
    },
    setProductSearch(search) {
      this.productSearch = search
    },
    setQuantityFilter(value) {
      this.quantityFilter = value
    },
    setProductCategory(categories) {

      this.productCategoriesNames = []
      let categoriesItems = categories.categories;

      categories.categoriesObjectRaw.forEach(item => {
        if (categoriesItems == null) {
          categoriesItems = []
        }
        if (categoriesItems.indexOf(item.id) > -1) {

          this.productCategoriesNames.push({
            name: item.name,
            slug: item.slug,
            id: item.id,
          })

        }
      })

      this.productCategories = categoriesItems
    },
    waitForBrand() {
      return this.productBrands != null && this.productBrands.length > 0;
    },
    waitForStore() {
      return this.productStores != null && this.productStores.length > 0;
    },
    waitForCategory() {
      return this.productCategories != null && this.productCategories.length > 0;
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    categorySliderCategory(category) {
      this.productCategories = [category.slug]
    },
    showRelatedCategoriesSlider() {
      if (this.productCategories != null && this.productCategories.length > 0) {
        this.singleCategory = this.productCategories[0]
        return true
      }

      return false
    },
    getScreenSizeName() {
      if (window.innerWidth <= 767) {
        this.screenSizeName = 'sm'
        return this.screenSizeName
      }
      this.screenSizeName = 'lg'
      return this.screenSizeName
    },
    publishStatus(value) {
      this.productStatus = value
    },
    setCategoryForWrapper(category) {
      // مقداردهی اولیه
      this.productCategories = []
      this.productCategoriesNames = []

      // افزودن فقط دسته‌بندی جدید
      if (this.productCategoryColumn === 'id') {
        this.productCategories.push(category.id)
      } else {
        this.productCategories.push(category.slug)
      }

      this.productCategoriesNames.push({
        name: category.name,
        slug: category.slug,
        id: category.id,
      })
    },
    setFilterPriceRange(price) {
      this.price = price
    },
    setCategoryFromFromTop(data) {
      let category = data.category
      let result = [];
      if (this.productCategoryColumn == 'slug') {
        result = category.slug
      } else {
        result = category.id
      }
      this.productCategories = [result]
    },
    setArchiveFilters(data) {
      this.archiveFilter = data
    },
    setProductSortFromQuery() {
      let sort = this.$route.query.sort;

      if (sort != '' && sort != undefined) {
        this.productSort = sort
      }

      return true


    },
    setStoresFilterDirectly() {
      this.productStores = this.productStoresDirectFilter
    },
    setFilterOrder(filterName) {
      const index = this.orderFilterProp.indexOf(filterName);
      if (index !== -1) {
        return `order-${index + 1}`;
      } else {
        return '';
      }

    },
  },
  beforeMount() {
    this.$store.commit("Product/setFilters", {key: "category_column", value: ''})
    this.$store.commit("Product/setFilters", {key: "category", value: []});

    this.$store.commit("Product/setFilters", {key: "brand", value: []});
    this.$store.commit("Product/setFilters", {key: "brand_column", value: ''})

    this.$store.commit("Product/setFilters", {key: "feature", value: []})


    this.setProductBrandFromQuery()
    this.setProductCategoryFromQuery()
    this.setProductStoreFromQuery()
    this.setProductPriceRangeFromQuery()
    this.setProductFeatureFromQuery()
    this.setProductSortFromQuery()
    this.setStoresFilterDirectly()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    window.addEventListener("resize", this.getScreenSizeName);
  },
  destroyed() {
    window.removeEventListener("resize", this.getScreenSizeName);
  },
}
</script>

<style scoped>
.mobile-filters-icon {
  z-index: 10;
  right: 25px;
  position: fixed;
}

.products-3-header-image {
  height: 250px;
  object-fit: cover;
  filter: brightness(40%);
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cursor-pointer {
  cursor: pointer;


}


</style>